var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    class: ["colorSerachTyphead calculationDataInput", _vm.typheadClass],
    attrs: {
      id: "footingColorSearch",
      type: "text",
      name: "colorCode",
      placeholder: ""
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }